// Non-blocking warnings. These are shown as soon as the value changes but never feed the proposal
// validation, so the user can still propose/submit while a warning is on screen.

import { isComparableNumber } from 'validators/estimateRelationshipValidators'

export const EMPTY_FIELD_WARNING = { field: '', message: '' }

export const HABITAT_PERCENTAGE_MAX = 100
export const HABITAT_PERCENTAGE_WARNING_MESSAGE = 'Please enter a number that does not exceed 100'

export const ECOLOGICAL_INTEGRITY_SITES_MAX = 2
export const ECOLOGICAL_INTEGRITY_SITES_WARNING_MESSAGE = 'Please enter a number that does not exceed 2'

// An empty or non-numeric value has nothing to compare, so it never warns.
export const exceedsMax = (value, max) => {
  return isComparableNumber(value) && Number(value) > max
}

export const getFieldWarning = (shouldWarn, field, message) => {
  return shouldWarn ? { field, message } : EMPTY_FIELD_WARNING
}

export const getHabitatPercentageWarning = (value, field) => {
  return getFieldWarning(exceedsMax(value, HABITAT_PERCENTAGE_MAX), field, HABITAT_PERCENTAGE_WARNING_MESSAGE)
}

export const getEcologicalIntegritySitesWarning = (value, field) => {
  return getFieldWarning(
    exceedsMax(value, ECOLOGICAL_INTEGRITY_SITES_MAX),
    field,
    ECOLOGICAL_INTEGRITY_SITES_WARNING_MESSAGE
  )
}
